export * from './structures/Result';
export * from './structures/Error';